<script lang="ts">
	/**
	 * Displays the visual stimulus (a large shape) or a fixation cross during ISI.
	 */

	import type { VisualStimulus } from './types';

	/** The current shape to display, or `null` during ISI / fixation. */
	let { stimulus, visible }: { stimulus: VisualStimulus | null; visible: boolean } =
		$props();
</script>

<div
	class="flex h-64 w-64 items-center justify-center rounded-2xl border-2 border-gray-600 bg-gray-900 text-center text-8xl transition-all duration-150"
	class:scale-100={visible}
	class:scale-75={!visible}
	class:opacity-100={visible}
	class:opacity-30={!visible}
	aria-live="polite"
	role="status"
>
	{#if stimulus && visible}
		<span class="select-none">{stimulus}</span>
	{:else}
		<span class="select-none text-4xl text-gray-500">+</span>
	{/if}
</div>
